import {OddsCellApiModel} from "./odds-cell.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {makeObservable, observable} from 'mobx';


export class OddsCellDomainModel extends BaseDomainModel {
  @observable text: String;
  @observable isBold: Boolean;

  constructor(model: OddsCellApiModel) {
    super(model);

    this.text = model.text;
    this.isBold = model.isBold;

    makeObservable(this);
  }
}
